import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'

const CreateApiClientButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.API_CLIENT_CREATE_MODAL })

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={() => showModal()}>
      Create API Client
    </Button>
  )
}

export default CreateApiClientButton
